import { render, staticRenderFns } from "./BusinessRules.vue?vue&type=template&id=5e5fd31d&scoped=true&lang=pug&"
import script from "./BusinessRules.vue?vue&type=script&lang=js&"
export * from "./BusinessRules.vue?vue&type=script&lang=js&"
import style0 from "./BusinessRules.vue?vue&type=style&index=0&id=5e5fd31d&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5fd31d",
  null
  
)

export default component.exports